<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page"><span>Summary Reports</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
        <div class="panel br-4">
          <div class="panel-body">
            <h3>Here is the summary of all Violation Action Reports!</h3>

            <!-- Loading Property -->
            <div v-if="isLoading" class="text-center p-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2">Loading reports...</p>
            </div>

            <div v-else>
              <!-- Violation Summary Counters -->
              <div class="row mb-4">
                <!-- Total Violations -->
                <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
                  <div class="stats-card card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <h6 class="mb-0">Total Violation</h6>
                          <h3 class="mt-2 mb-0">
                            <count-to :start-val="0" :end-val="totalViolations" :duration="2000" />
                          </h3>
                        </div>
                        <div class="icon-bg">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="feather feather-alert-triangle">
                            <path
                              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                            </path>
                            <line x1="12" y1="9" x2="12" y2="13"></line>
                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                          </svg>
                        </div>
                      </div>
                      <p class="mt-3 mb-0 text-muted text-sm">
                        <span class="text-secondary mr-2">
                          <i class="fa fa-arrow-up"></i> Action Events
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Drivers With Violations -->
                <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
                  <div class="stats-card card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <h6 class="mb-0">Violating Drivers</h6>
                          <h3 class="mt-2 mb-0">
                            <count-to :start-val="0" :end-val="violatingDrivers" :duration="2000" />
                          </h3>
                        </div>
                        <div class="icon-bg">
                          <router-link to="/violation/reports/drivers">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="feather feather-users">
                              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                              <circle cx="9" cy="7" r="4"></circle>
                              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                          </router-link>
                        </div>
                      </div>
                      <p class="mt-3 mb-0 text-muted text-sm">
                        <span class="text-warning mr-2">
                          {{ repeatOffenders }} repeat offenders
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Violation Types -->
                <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
                  <div class="stats-card card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <h6 class="mb-0">Violation Types</h6>
                          <h3 class="mt-2 mb-0">
                            <count-to :start-val="0" :end-val="violationTypes" :duration="2000" />
                          </h3>
                        </div>
                        <router-link to="/violation/parameters/view">
                          <div class="icon-bg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="feather feather-list">
                              <line x1="8" y1="6" x2="21" y2="6"></line>
                              <line x1="8" y1="12" x2="21" y2="12"></line>
                              <line x1="8" y1="18" x2="21" y2="18"></line>
                              <line x1="3" y1="6" x2="3.01" y2="6"></line>
                              <line x1="3" y1="12" x2="3.01" y2="12"></line>
                              <line x1="3" y1="18" x2="3.01" y2="18"></line>
                            </svg>
                          </div>
                        </router-link>
                      </div>
                      <p class="mt-3 mb-0 text-muted text-sm">
                        <span class="text-info mr-2">
                          {{ mostCommonViolation }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Recent Violations -->
                <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
                  <div class="stats-card card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <h6 class="mb-0">Recent Violations</h6>
                          <h3 class="mt-2 mb-0">
                            <count-to :start-val="0" :end-val="recentViolations" :duration="2000" />
                          </h3>
                        </div>
                        <div class="icon-bg">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="feather feather-clock">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                        </div>
                      </div>
                      <p class="mt-3 mb-0 text-muted text-sm">
                        <span class="text-success mr-2">
                          Added {{ newViolationsThisWeek }} new this week
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Drivers With Warning Letters -->
                <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
                  <div class="stats-card card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between">
                        <div>
                          <h6 class="mb-0">Drivers With Warning Letters</h6>
                          <h3 class="mt-2 mb-0">
                            <count-to :start-val="0" :end-val="driversWithWarningLetters" :duration="2000" />
                          </h3>
                        </div>
                        <router-link to="/violation/action/warning-letters/list">
                          <div class="icon-bg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="feather feather-alert-octagon">
                              <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2">
                              </polygon>
                              <line x1="12" y1="8" x2="12" y2="12"></line>
                              <line x1="12" y1="16" x2="12.01" y2="16"></line>
                            </svg>
                          </div>
                        </router-link>
                      </div>
                      <p class="mt-3 mb-0 text-muted text-sm">
                        <span class="text-danger mr-2">
                          {{ repeatWarningLetterOffenders }} repeat offenders
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div> <!-- End of Violation Summary Counters -->
            </div> <!-- End of v-else -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useMeta } from '@/composables/use-meta';
import { ref, computed, onMounted } from 'vue';
import { CountTo } from 'vue3-count-to';
import axios from 'axios';
import { BASE_URL, BASE_URL_2 } from '@/Config/config';
import Swal from 'sweetalert2';
import { useStore } from 'vuex';

useMeta({ title: 'Summary Reports' });

const isLoading = ref(false);
const violations = ref([]);
const violationActions = ref([]);
const violationParameters = ref([]);
const drivers = ref([]);
const trucks = ref([]);
const trailers = ref([]);
const loading_order_item = ref([]);
const store = useStore();

onMounted(async () => {
  isLoading.value = true;
  try {
    const responses = await Promise.all([
      axios.get(`${BASE_URL}/violations`, {
        headers: {
          'Authorization': `Bearer ${store.state.token}`,
          'X-Company-ID': store.state.currentCompany?.id
        }
      }),
      axios.get(`${BASE_URL}/violation-actions`, {
        headers: {
          'Authorization': `Bearer ${store.state.token}`,
          'X-Company-ID': store.state.currentCompany?.id
        }
      }),
      axios.get(`${BASE_URL}/violation-parameters`, {
        headers: {
          'Authorization': `Bearer ${store.state.token}`,
          'X-Company-ID': store.state.currentCompany?.id
        }
      }),
      axios.get(`${BASE_URL_2}/employee/driver/show`),
      axios.get(`${BASE_URL_2}/vehicle/truck/show`),
      axios.get(`${BASE_URL_2}/vehicle/trailer/show`),
      axios.get(`${BASE_URL_2}/loading-order-item/show`)
    ]);

    // Process responses
    violations.value = responses[0].data.data || responses[0].data;
    violationActions.value = responses[1].data.data || responses[1].data;
    violationParameters.value = responses[2].data.data || responses[2].data;
    drivers.value = responses[3].data.drivers || responses[3].data.data || responses[3].data;
    trucks.value = responses[4].data.trucks || responses[4].data.data || responses[4].data;
    trailers.value = responses[5].data.trailers || responses[5].data.data || responses[5].data;
    loading_order_item.value = responses[6].data.loading_order_items || responses[6].data.data || responses[6].data;

    console.log('API Response:', {
      violations: responses[0].status,
      actions: responses[1].status,
      violationParameters: responses[2].status,
      drivers: responses[3].status,
      trucks: responses[4].status,
      trailers: responses[5].status,
      loading_order_item: responses[6].status
    });

  } catch (err) {
    console.error("Failed to load data:", err);
    // Add error message to user
    Swal.fire({
      icon: 'error',
      title: 'Failed to load data',
      text: err.message || 'Please try again later',
      confirmButtonColor: '#3085d6'
    });
  } finally {
    isLoading.value = false;
  }
});

// Computed properties
const totalViolations = computed(() => violationActions.value.length);

const violatingDrivers = computed(() => {
  const drivers = new Set()
  violationActions.value.forEach(action => {
    if (action.employee_id) drivers.add(action.employee_id)
  })
  return drivers.size
})

const repeatOffenders = computed(() => {
  const driverCounts = {}
  violationActions.value.forEach(action => {
    if (action.employee_id) {
      driverCounts[action.employee_id] = (driverCounts[action.employee_id] || 0) + 1
    }
  })
  return Object.values(driverCounts).filter(count => count > 1).length
})

const violationTypes = computed(() => {
  const types = new Set()
  violationActions.value.forEach(action => {
    if (action.violation_id) types.add(action.violation_id)
  })
  return types.size
})

const mostCommonViolation = computed(() => {
  const violationCounts = {}
  violationActions.value.forEach(action => {
    if (action.violation_id) {
      violationCounts[action.violation_id] = (violationCounts[action.violation_id] || 0) + 1
    }
  })
  const mostCommon = Object.entries(violationCounts).sort((a, b) => b[1] - a[1])[0]
  return mostCommon ? `Most common: ${mostCommon[0]}` : 'No data'
})

const newViolationsThisWeek = computed(() => {
  const oneWeekAgo = new Date()
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7)
  return violationActions.value.filter(action => {
    const actionDate = new Date(action.created_at)
    return actionDate >= oneWeekAgo
  }).length
})

const recentViolations = computed(() => {
  const oneMonthAgo = new Date()
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)
  return violationActions.value.filter(action => {
    const actionDate = new Date(action.created_at)
    return actionDate >= oneMonthAgo
  }).length
});

const driversWithWarningLetters = computed(() => {
  const driversWithWarnings = new Set();
  violationActions.value.forEach(action => {
    if (action.taken_action?.name === 'Warning Letter' && action.employee_id) {
      driversWithWarnings.add(action.employee_id);
    }
  });
  return driversWithWarnings.size;
});

const repeatWarningLetterOffenders = computed(() => {
  const warningCounts = {};
  violationActions.value.forEach(action => {
    if (action.taken_action?.name === 'Warning Letter' && action.employee_id) {
      warningCounts[action.employee_id] = (warningCounts[action.employee_id] || 0) + 1;
    }
  });
  return Object.values(warningCounts).filter(count => count > 1).length;
});
</script>

<style scoped>
.layout-px-spacing {
  min-height: calc(100vh - 170px) !important;
}

.stats-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 4px 20px 1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 25px 1px rgba(0, 0, 0, 0.1);
}

.icon-bg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(94, 114, 228, 0.1);
}

.icon-bg svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.5;
  color: #5e72e4;
}

h6 {
  font-size: 14px;
  color: #6c757d;
  font-weight: 600;
}

h3 {
  font-size: 28px;
  font-weight: 700;
  color: #3c4d69;
}

.text-sm {
  font-size: 12px;
}

.text-success {
  color: #2dce89 !important;
}

.text-warning {
  color: #fb6340 !important;
}

.text-info {
  color: #11cdef !important;
}

.text-danger {
  color: #f5365c !important;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.feather {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}
</style>